/**
 * This file contains helpers for local development
 */

import { getRuntimeEnvName } from "@granular/fabric-core";

/**
 * This is simply a collection of functions to run onSuccess or onFail
 * when we are attempting to load the "./App" module.
 *
 * The purpose of these functions is to allow for a single hard auto-reload
 * when developing locally as sometimes webpack does not seem to
 * correctly process changes in nested packages and will simply require
 * a single hard reload of the page.
 */
const moduleLoadRetryManager = (() => {
  const baseBackoffMs = 2000;
  const sessionStorageKey =
    "[fabric][container][local][retries-after-module-fail]";

  const isLocal = getRuntimeEnvName() === "local";

  const onFail = () => {
    if (isLocal) {
      const storageResult = window.sessionStorage.getItem(sessionStorageKey);

      let retryCount = storageResult && Number(storageResult);
      if (!retryCount || Number.isNaN(retryCount)) {
        retryCount = 0;
      }

      window.sessionStorage.setItem(sessionStorageKey, `${retryCount + 1}`);

      const retryInMs = retryCount * baseBackoffMs; // exponential backoff
      console.log(`Retrying in ${retryInMs / 1000} seconds...`);

      window.setTimeout(() => {
        window.location.reload();
      }, retryInMs);
    }
  };

  const onSuccess = () => {
    if (isLocal) {
      window.sessionStorage.removeItem(sessionStorageKey);
    }
  };

  return {
    onFail,
    onSuccess,
  };
})();

export const localDevelopmentHelpers = { moduleLoadRetryManager };
